/**
 * Phone number formatting utility
 * Formats phone numbers to the required format: "074 551 1155"
 */

/**
 * Formats a phone number to the required format with spaces
 * @param {string} phoneNumber - The phone number to format
 * @returns {string} - Formatted phone number
 */
export function formatPhoneNumber(phoneNumber) {
  if (!phoneNumber) return '';
  
  // Remove all non-digit characters
  const digits = phoneNumber.replace(/\D/g, '');
  
  // If less than 10 digits, return as is
  if (digits.length < 10) return phoneNumber;
  
  // Format as XXX XXX XXXX
  if (digits.length >= 10) {
    return `${digits.slice(0, 3)} ${digits.slice(3, 6)} ${digits.slice(6, 10)}`;
  }
  
  return phoneNumber;
}

/**
 * Validates if a phone number is in the correct format
 * @param {string} phoneNumber - The phone number to validate
 * @returns {boolean} - True if valid format
 */
export function validatePhoneFormat(phoneNumber) {
  if (!phoneNumber) return false;
  
  // Remove all non-digit characters
  const digits = phoneNumber.replace(/\D/g, '');
  
  // Must be exactly 10 digits
  return digits.length === 10;
}

/**
 * Formats phone number on input (for v-model)
 * @param {string} value - The input value
 * @returns {string} - Formatted value
 */
export function formatPhoneInput(value) {
  if (!value) return '';
  
  // Remove all non-digit characters
  const digits = value.replace(/\D/g, '');
  
  // Limit to 10 digits
  const limitedDigits = digits.slice(0, 10);
  
  // Format as user types
  if (limitedDigits.length <= 3) {
    return limitedDigits;
  } else if (limitedDigits.length <= 6) {
    return `${limitedDigits.slice(0, 3)} ${limitedDigits.slice(3)}`;
  } else {
    return `${limitedDigits.slice(0, 3)} ${limitedDigits.slice(3, 6)} ${limitedDigits.slice(6)}`;
  }
}

/**
 * Gets phone number validation rules for Vuetify
 * @returns {Array} - Array of validation rules
 */
export function getPhoneValidationRules() {
  return [
    v => !!v || 'Phone number is required',
    v => validatePhoneFormat(v) || 'Phone number must be 10 digits (e.g., 074 551 1155)'
  ];
}
